import { Box } from "@mui/material";
import ControlPointOutlinedIcon from "@mui/icons-material/ControlPointOutlined";
import { useRecoilState } from "recoil";
import { newHSCodesAnimationState } from "../../../atoms/membership";

const AddHSCodes = () => {
  const [, setNewHSCodesAnimation] = useRecoilState(newHSCodesAnimationState);

  return (
    <Box className="new-address-adder-wrapper">
      <button onClick={() => setNewHSCodesAnimation(true)} className="new-address-adder">
        <ControlPointOutlinedIcon />
        HS Kodu Ekle
      </button>
    </Box>
  );
};

export default AddHSCodes;
